
(function () {
  "use strict";

  var ROOT = document.getElementById("fde");
  if (!ROOT) return;

  /* ── Left carousel ── */
  var trackOuter = ROOT.querySelector(".fde-track-outer");
  var prevBtn    = ROOT.querySelector("[data-prev]");
  var nextBtn    = ROOT.querySelector("[data-next]");

  var current     = 0;
  var activePanel = null; // currently visible ul.fde-tab-panel

  /* ── Helpers ── */

  /* <=960px scrolls natively for real momentum; transform paging is desktop
     only. Breakpoint must match bm-collection-tab.css. */
  var nativeMQ = window.matchMedia("(max-width: 960px)");
  function isNative() { return nativeMQ.matches; }

  /* One card + gap = the arrow step distance. */
  function stepWidth(scroller) {
    var first = scroller ? scroller.querySelector("li.product-card") : null;
    if (!first) return 0;
    var style = getComputedStyle(scroller);
    var gap   = parseFloat(style.columnGap || style.gap || 0) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  /* How many cards fit one visible row — the arrow's page size. Measured, not
     hardcoded, so it follows the CSS breakpoints (5 / 4 / 3 cards per row). */
  function cardsPerView(scroller, outer) {
    if (!scroller || !outer) return 1;
    var step = stepWidth(scroller);
    if (!step) return 1;
    var outerW = outer.getBoundingClientRect().width || outer.offsetWidth;
    return Math.max(1, Math.round(outerW / step));
  }

  /* `.fde-nav:disabled { display: none }` — disabled is what hides an arrow. */
  function syncNativeNav(scroller, prev, next) {
    if (!scroller) return;
    var max = scroller.scrollWidth - scroller.clientWidth;
    var x   = scroller.scrollLeft;
    if (prev) prev.disabled = x <= 1;
    if (next) next.disabled = max <= 1 || x >= max - 1;
  }

  /* Nudge one card; the scroll listener refreshes the buttons. */
  function nativeStep(scroller, dir) {
    if (!scroller) return;
    var step = stepWidth(scroller);
    if (!step) return;
    if (scroller.scrollBy) scroller.scrollBy({ left: dir * step, behavior: "smooth" });
    else scroller.scrollLeft += dir * step; // scroll-behavior in CSS animates this
  }

  /* One arrow click = one full row of cards. */
  function pageStep(dir) {
    goTo(current + dir * cardsPerView(activePanel, trackOuter));
  }

  /**
   * Translate the active panel and update nav button states.
   * Clamps in pixels, not by card index, so the last card ends flush right —
   * an index clamp rounds fractional layouts (1.5 cards) up and strands it.
   */
  function goTo(idx) {
    if (!activePanel || !trackOuter) return;

    // Native scrolling owns the position on mobile — only refresh the arrows.
    if (isNative()) { syncNativeNav(activePanel, prevBtn, nextBtn); return; }

    var cards = activePanel.querySelectorAll("li.product-card");
    var total = cards.length;
    if (!total) return;

    idx = Math.max(0, Math.min(idx, total - 1));

    var outerW = trackOuter.getBoundingClientRect().width || trackOuter.offsetWidth;
    // offsetLeft ignores transforms; measure from card 0 to cancel panel offset.
    var base   = cards[0].offsetLeft;
    var last   = cards[total - 1];
    var offset = cards[idx].offsetLeft - base;

    var maxOffset = Math.max(0, (last.offsetLeft - base) + last.offsetWidth - outerW);
    offset = Math.min(offset, maxOffset);

    // When the last page is clamped short, re-seat `current` on the card actually
    // at the left edge — otherwise the next Prev would page back from a phantom
    // index and land less than a row from where the user sees the row start.
    if (offset < (cards[idx].offsetLeft - base)) {
      for (var i = total - 1; i >= 0; i--) {
        if (cards[i].offsetLeft - base <= offset + 1) { idx = i; break; }
      }
    }

    current = idx;
    activePanel.style.transform = "translateX(-" + offset + "px)";

    prevBtn.disabled = offset <= 0;
    nextBtn.disabled = offset >= maxOffset;
  }

  /**
   * Switch to the tab whose panel has the given data-tab-panel id.
   * Resets the carousel position for the new panel.
   */
  function renderTab(tabId) {
    // Hide all panels
    var allPanels = ROOT.querySelectorAll(".fde-tab-panel");
    allPanels.forEach(function (p) {
      p.classList.remove("is-active");
      p.setAttribute("aria-hidden", "true");
      p.style.transform = "translateX(0)";
      p.scrollLeft = 0; // reset the native-scroll offset too
    });

    // Show the requested panel
    var panel = ROOT.querySelector('[data-tab-panel="' + tabId + '"]');
    if (!panel) return;

    panel.classList.add("is-active");
    panel.setAttribute("aria-hidden", "false");
    activePanel = panel;
    current     = 0;

    // Defer goTo so the browser has laid out the newly-visible panel
    requestAnimationFrame(function () {
      goTo(0);
      requestTimerSync();
    });
  }

  /* ── Tab buttons ── */
  var tabs = ROOT.querySelectorAll(".fde-tab");
  var footerNote = ROOT.querySelector(".fde-footer-note");

  /* Swap the footer banner image + aspect ratio to match the active tab.
     data-footer-banner already includes the section-level fallback (resolved
     in Liquid), so an empty value means "no banner at all" → clear it and let
     the plain note/solid background show. */
  function updateFooterBanner(tab) {
    if (!footerNote || !tab) return;
    var img    = tab.getAttribute("data-footer-banner");
    var ar     = tab.getAttribute("data-footer-ar");
    var imgMob = tab.getAttribute("data-footer-banner-mob");
    var arMob  = tab.getAttribute("data-footer-ar-mob");
    if (img) {
      footerNote.style.setProperty("--footer-banner", "url('" + img + "')");
      if (ar) footerNote.style.setProperty("--footer-ar", ar);
      footerNote.classList.add("has-banner");

      // Mobile variant is optional — set it when provided, otherwise clear any
      // stale value so the CSS falls back to the desktop banner/ratio.
      if (imgMob) {
        footerNote.style.setProperty("--footer-banner-mob", "url('" + imgMob + "')");
        if (arMob) footerNote.style.setProperty("--footer-ar-mob", arMob);
        else footerNote.style.removeProperty("--footer-ar-mob");
      } else {
        footerNote.style.removeProperty("--footer-banner-mob");
        footerNote.style.removeProperty("--footer-ar-mob");
      }
    } else {
      footerNote.style.removeProperty("--footer-banner");
      footerNote.style.removeProperty("--footer-ar");
      footerNote.style.removeProperty("--footer-banner-mob");
      footerNote.style.removeProperty("--footer-ar-mob");
      footerNote.classList.remove("has-banner");
    }
  }

  /* Swap the footer note to match the active tab. Like the banner, the attribute
     already carries the section-level fallback, so empty means "no note". */
  function updateFooterNote(tab) {
    if (!footerNote || !tab) return;
    // innerHTML, not textContent: inline_richtext may contain <b>/<i>/<a>.
    var note = tab.getAttribute("data-footer-note") || "";
    footerNote.innerHTML = note;
    footerNote.classList.toggle("is-empty", note === "");
  }

  function switchTab(tab) {
    var id = tab.dataset.tab;
    tabs.forEach(function (t) {
      t.classList.toggle("is-active", t === tab);
      t.setAttribute("aria-selected", String(t === tab));
    });
    renderTab(id);
    updateFooterBanner(tab);
    updateFooterNote(tab);
  }

  tabs.forEach(function (t) {
    t.addEventListener("click", function () { switchTab(t); });
  });

  /* ── Left nav buttons ── */
  prevBtn.addEventListener("click", function () {
    if (isNative()) nativeStep(activePanel, -1);
    else pageStep(-1);
  });
  nextBtn.addEventListener("click", function () {
    if (isNative()) nativeStep(activePanel, 1);
    else pageStep(1);
  });

  /* Keep arrows in step with a native scroll. */
  ROOT.querySelectorAll(".fde-tab-panel").forEach(function (p) {
    p.addEventListener("scroll", function () {
      if (isNative() && p === activePanel) syncNativeNav(p, prevBtn, nextBtn);
    }, { passive: true });
  });

  /* ── Touch — left carousel ── */
  var touchStartX = 0;
  var touchStartY = 0;
  var touchMoved  = false;

  trackOuter.addEventListener("touchstart", function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchMoved  = false;
  }, { passive: true });

  trackOuter.addEventListener("touchmove", function () {
    touchMoved = true;
  }, { passive: true });

  trackOuter.addEventListener("touchend", function (e) {
    if (isNative()) return; // the browser is handling the gesture
    if (!touchMoved) return;
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      pageStep(dx < 0 ? 1 : -1);
    }
  }, { passive: true });

  var lastViewportWidth = window.innerWidth;
  var rt;
  window.addEventListener("resize", function () {
    var newWidth = window.innerWidth;
    if (newWidth === lastViewportWidth) return;
    lastViewportWidth = newWidth;
    clearTimeout(rt);
    rt = setTimeout(function () {
      applyMode();
      requestTimerSync();
    }, 150);
  });

  /* On breakpoint change, zero the other mode's offset so scrollLeft and
     transform never stack. */
  var wasNative = isNative();
  function applyMode() {
    var nowNative = isNative();
    if (nowNative !== wasNative) {
      ROOT.querySelectorAll(".fde-tab-panel").forEach(function (p) { p.scrollLeft = 0; });
      if (ebTrack) ebTrack.scrollLeft = 0;
      current   = 0;
      ebCurrent = 0;
      wasNative = nowNative;
    }
    goTo(current);
    ebGoTo(ebCurrent);
    requestTimerSync();
  }

  var firstTab = ROOT.querySelector(".fde-tab.is-active");
  if (firstTab) {
    activePanel = ROOT.querySelector('[data-tab-panel="' + firstTab.dataset.tab + '"]');
    updateFooterBanner(firstTab);
    requestAnimationFrame(function () { goTo(0); });
  }


  /* ────────────────────────────────────────────
     Right panel (eb) carousel — mobile only
     The CSS hides nav buttons on desktop; JS runs
     everywhere but is harmless when hidden.
  ──────────────────────────────────────────── */

  var ebTrack  = ROOT.querySelector("[data-eb-track]");
  var ebOuter  = ROOT.querySelector(".eb-sea-track-outer");
  var ebPrev   = ROOT.querySelector("[data-eb-prev]");
  var ebNext   = ROOT.querySelector("[data-eb-next]");

  var ebCurrent = 0;

  function ebCardWidth() {
    var first = ebTrack ? ebTrack.querySelector("li.product-card") : null;
    if (!first) return 0;
    var style = getComputedStyle(ebTrack);
    var gap   = parseFloat(style.columnGap || style.gap || 0) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  /**
   * Go to a card index; clamp so the last card is always
   * fully visible when the user reaches the end.
   */
  function ebGoTo(idx) {
    if (!ebTrack || !ebOuter) return;

    // Native scrolling owns the position on mobile — only refresh the arrows.
    if (isNative()) { syncNativeNav(ebTrack, ebPrev, ebNext); return; }

    var cards = ebTrack.querySelectorAll("li.product-card");
    var total = cards.length;
    if (!total) return;

    idx = Math.max(0, Math.min(idx, total - 1));

    var outerW    = ebOuter.offsetWidth;
    var offset    = cards[idx].offsetLeft;
    var maxOffset = cards[total - 1].offsetLeft + cards[total - 1].offsetWidth - outerW;
    maxOffset     = Math.max(0, maxOffset);

    offset = Math.min(offset, maxOffset);

    ebCurrent = idx;
    ebTrack.style.transform = "translateX(-" + offset + "px)";

    if (ebPrev) ebPrev.disabled = offset <= 0;
    if (ebNext) ebNext.disabled = offset >= maxOffset;
  }

  if (ebPrev) ebPrev.addEventListener("click", function () {
    if (isNative()) nativeStep(ebTrack, -1);
    else ebGoTo(ebCurrent - 1);
  });
  if (ebNext) ebNext.addEventListener("click", function () {
    if (isNative()) nativeStep(ebTrack, 1);
    else ebGoTo(ebCurrent + 1);
  });

  if (ebTrack) ebTrack.addEventListener("scroll", function () {
    if (isNative()) syncNativeNav(ebTrack, ebPrev, ebNext);
  }, { passive: true });

  /* ── Touch — right carousel ── */
  if (ebOuter) {
    var etSX = 0, etSY = 0, etMoved = false;

    ebOuter.addEventListener("touchstart", function (e) {
      etSX    = e.touches[0].clientX;
      etSY    = e.touches[0].clientY;
      etMoved = false;
    }, { passive: true });

    ebOuter.addEventListener("touchmove", function () {
      etMoved = true;
    }, { passive: true });

    ebOuter.addEventListener("touchend", function (e) {
      if (isNative()) return; // the browser is handling the gesture
      if (!etMoved) return;
      var dx = e.changedTouches[0].clientX - etSX;
      var dy = e.changedTouches[0].clientY - etSY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        ebGoTo(dx < 0 ? ebCurrent + 1 : ebCurrent - 1);
      }
    }, { passive: true });
  }

  /* ── Initialise right carousel ── */
  requestAnimationFrame(function () { ebGoTo(0); });


  /* ────────────────────────────────────────────
     Countdown Timer Space Alignment
  ──────────────────────────────────────────── */

  function ensureTimerSpaces() {
    ROOT.querySelectorAll("li.product-card").forEach(function (card) {
      if (card.querySelector(".fde-timer-space")) return;
      var timer = card.querySelector(".bm-plp-timer");
      var space = document.createElement("div");
      space.className = "fde-timer-space";
      if (timer) {
        timer.parentNode.insertBefore(space, timer);
        space.appendChild(timer);
      } else {
        var staticContainer = card.querySelector(".static");
        if (staticContainer) {
          var btn = staticContainer.querySelector(".link-btn, form.form-card, .collection-compare-pick");
          if (btn) {
            staticContainer.insertBefore(space, btn);
          } else {
            staticContainer.appendChild(space);
          }
        }
      }
    });
  }

  function isTimerActive(timerEl) {
    if (!timerEl) return false;
    if (timerEl.hasAttribute("hidden")) return false;
    if (timerEl.classList.contains("is-hidden")) return false;
    if (timerEl.closest("[hidden]")) return false;

    // A timer inside an inactive left tab panel is not active/visible
    var panel = timerEl.closest(".fde-tab-panel");
    if (panel && !panel.classList.contains("is-active")) return false;

    var style = window.getComputedStyle(timerEl);
    if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") {
      return false;
    }

    return (timerEl.offsetWidth > 0 || timerEl.offsetHeight > 0 || timerEl.getClientRects().length > 0);
  }

  function getTimerRenderedHeight(timerEl) {
    if (!timerEl) return 0;
    var rect = timerEl.getBoundingClientRect();
    var style = window.getComputedStyle(timerEl);
    var marginTop = parseFloat(style.marginTop) || 0;
    var marginBottom = parseFloat(style.marginBottom) || 0;
    var height = timerEl.offsetHeight || Math.round(rect.height);
    return Math.round(height + marginTop + marginBottom);
  }

  var syncTimerScheduled = false;
  function syncTimerAlignment() {
    syncTimerScheduled = false;
    ensureTimerSpaces();

    // 1. Detect active/visible countdown timers on LEFT side (in active tab panel)
    var leftPanel = ROOT.querySelector(".fde-left .fde-tab-panel.is-active") || ROOT.querySelector(".fde-left");
    var leftTimers = leftPanel ? Array.from(leftPanel.querySelectorAll(".bm-plp-timer")) : [];
    var leftActiveTimers = leftTimers.filter(isTimerActive);
    var leftMaxHeight = 0;
    leftActiveTimers.forEach(function (timer) {
      var h = getTimerRenderedHeight(timer);
      if (h > leftMaxHeight) leftMaxHeight = h;
    });

    // 2. Detect active/visible countdown timers on RIGHT side
    var rightContainer = ROOT.querySelector(".fde-right");
    var rightTimers = rightContainer ? Array.from(rightContainer.querySelectorAll(".bm-plp-timer")) : [];
    var rightActiveTimers = rightTimers.filter(isTimerActive);
    var rightMaxHeight = 0;
    rightActiveTimers.forEach(function (timer) {
      var h = getTimerRenderedHeight(timer);
      if (h > rightMaxHeight) rightMaxHeight = h;
    });

    // 3. Compare and determine the required timer-space height
    var requiredHeight = Math.max(leftMaxHeight, rightMaxHeight);

    // 4. Apply min-height to reserved space on both sides
    if (requiredHeight > 0) {
      ROOT.style.setProperty("--fde-timer-space", requiredHeight + "px");
      ROOT.classList.add("has-timer-space");
    } else {
      ROOT.style.removeProperty("--fde-timer-space");
      ROOT.classList.remove("has-timer-space");
    }
  }

  function requestTimerSync() {
    if (syncTimerScheduled) return;
    syncTimerScheduled = true;
    requestAnimationFrame(syncTimerAlignment);
  }

  // Initial sync and delayed checks for async countdown campaign evaluation
  requestTimerSync();
  setTimeout(requestTimerSync, 200);
  setTimeout(requestTimerSync, 800);
  window.addEventListener("load", requestTimerSync);

  // Dynamic observers: watch for timers becoming active, hidden, or ending
  if (window.MutationObserver) {
    var timerObserver = new MutationObserver(function (mutations) {
      var shouldSync = false;
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (!target) continue;
        if (target.nodeType === 1 && (
          target.classList.contains("bm-plp-timer") ||
          target.classList.contains("is-hidden") ||
          target.closest(".bm-plp-timer") ||
          target.classList.contains("fde-tab-panel") ||
          target.hasAttribute("data-countdown-timer") ||
          target.hasAttribute("data-product-card-deal-countdown")
        )) {
          shouldSync = true;
          break;
        }
      }
      if (shouldSync) requestTimerSync();
    });
    timerObserver.observe(ROOT, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "hidden", "style"]
    });
  }

  if (window.ResizeObserver) {
    var timerResizeObserver = new ResizeObserver(function () {
      requestTimerSync();
    });
    timerResizeObserver.observe(ROOT);
  }

})();